var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 59,
    viewBox: "0 0 50 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 44.275V14.725L24.9511 0L50 14.725V44.275L24.9511 59L0 44.275Z",
    fill: "#A6192D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7396 40.719C27.3482 40.719 27.0546 40.4185 27.0546 40.0179V25.2929C27.0546 24.8922 27.3482 24.5917 27.7396 24.5917C28.131 24.5917 28.4245 24.2912 28.4245 23.8905C28.4245 23.4898 28.131 23.1893 27.7396 23.1893H22.2601C21.8687 23.1893 21.5752 23.4898 21.5752 23.8905C21.5752 24.2912 21.8687 24.5917 22.2601 24.5917C22.6515 24.5917 22.9451 24.8922 22.9451 25.2929V40.0179C22.9451 40.4185 22.6515 40.719 22.2601 40.719C21.8687 40.719 21.5752 41.0195 21.5752 41.4202C21.5752 41.8209 21.8687 42.1214 22.2601 42.1214H27.7396C28.131 42.1214 28.4245 41.8209 28.4245 41.4202C28.4245 41.0195 28.131 40.719 27.7396 40.719Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9996 21.0858C26.1344 21.0858 27.0544 20.144 27.0544 18.9822C27.0544 17.8205 26.1344 16.8787 24.9996 16.8787C23.8648 16.8787 22.9448 17.8205 22.9448 18.9822C22.9448 20.144 23.8648 21.0858 24.9996 21.0858Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.f797954dc619c4e5e4df88a851ff6c28.svg";
export { ForwardRef as ReactComponent };